var styleDataHash = "7245d0d5";
const injectCss = (() => {
  var css = `._8LjnB{--shimmer-base-color:#f5f5f5;background-color:var(--shimmer-base-color);pointer-events:none;z-index:1}._8LjnB,.tfh-R{inset:0;position:absolute}.tfh-R{overflow:hidden}.tfh-R:after{animation:NdfpI 1s linear infinite;background:linear-gradient(90deg,transparent,hsla(0,0%,100%,.3),transparent 50%);bottom:0;content:"";left:0;position:absolute;right:0;top:0;transform:translateX(-100%)}@keyframes NdfpI{to{transform:translateX(100%)}}._0lvR6{bottom:12px;left:50%;position:absolute;transform:translateX(-50%);z-index:2}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var layout_background_loader_default = {
  "overlay": "_8LjnB",
  "shimmer": "tfh-R",
  "layout-shimmer": "NdfpI",
  "label": "_0lvR6"
};
export {
  layout_background_loader_default as default,
  injectCss
};
//# sourceMappingURL=layout-background-loader-scss.js.map
